import React, { forwardRef, useState } from 'react';
import { OFlowModel } from '../model';
import { generateOFlowId, getSortedComponents } from '../utils';
import { OFlowContext } from './context';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
;
/** OFlow-Container */
const ContainerComponent = (props, ref) => {
    const { config, children, style = { height: '100%' }, className } = props;
    /** 初始时创建oFlowId*/
    const [oFlowId] = useState(props.oFlowId ? props.oFlowId : generateOFlowId());
    OFlowModel.buildModel(oFlowId, () => { config === null || config === void 0 ? void 0 : config(oFlowId); });
    const { resourcePanel, toolbar, canvas, configPanel, consolePanel } = getSortedComponents(children);
    const getLayoutChildren = () => {
        const layoutType = OFlowModel.getModel(oFlowId).getLayoutType();
        if (layoutType === 'COVERED' || layoutType === 'VERTICAL') {
            return React.createElement("div", { style: { flexGrow: 1, display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden' } },
                toolbar,
                React.createElement("div", { style: { flexGrow: 1, display: 'flex', overflow: 'hidden' } },
                    canvas,
                    configPanel),
                consolePanel);
        }
        else if (layoutType === 'HORIZONTAL') {
            return React.createElement("div", { style: { flexGrow: 1, display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden' } },
                toolbar,
                React.createElement("div", { style: { flexGrow: 1, display: 'flex', overflow: 'hidden' } },
                    React.createElement("div", { style: { height: '100%', flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' } },
                        canvas,
                        consolePanel),
                    configPanel));
        }
    };
    return React.createElement(DndProvider, { backend: HTML5Backend, key: `oflow-container--${oFlowId}` },
        React.createElement("div", { className: className, key: oFlowId, ref: (dom) => {
                var _a;
                if (ref) {
                    ref.current = dom;
                }
                ;
                (_a = OFlowModel.getModel(oFlowId)) === null || _a === void 0 ? void 0 : _a.setContainerDom(dom);
            }, style: Object.assign({ width: '100%', height: '100%', display: 'flex', overflow: 'hidden' }, style) },
            React.createElement(OFlowContext.Provider, { value: { oFlowId }, key: oFlowId },
                React.createElement("div", null, resourcePanel),
                getLayoutChildren()),
            React.createElement("div", { key: `oflow-client--dnd-preview-${oFlowId}`, id: `oflow-client--dnd-preview-${oFlowId}`, style: { position: 'fixed', left: -999, bottom: -999, zIndex: -99 } })));
};
export const Container = forwardRef(ContainerComponent);
export const useOflowContext = () => {
    return React.useContext(OFlowContext);
};
//# sourceMappingURL=index.js.map